"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProfileOrdersItem = void 0;
const gs_1 = require("@ivanlog/gs");
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const ClassesTags_1 = require("../ClassesTags");
const Helper_1 = require("../Helper");
const models_1 = require("../api/classes/models");
const FilesTags_1 = require("../FilesTags");
const AppPM_1 = require("../../appProfiMall/AppPM");
const StateCart_1 = require("../../appProfiMall/states/StateCart");
class CmpProfileOrdersItem extends tmpls_1.CmpProfileOrdersItemBase {
    constructor() {
        super();
        this._productsLoaded = false;
        this.ctrls.btnHeader.onclick = () => {
            this.flipClass(ClassesTags_1.ClassesTags.Active);
            if (!this._productsLoaded && this.hasClass(ClassesTags_1.ClassesTags.Active)) {
                this._productsLoaded = true;
                this._loadProductsAsync();
            }
        };
        this.ctrls.btnPayOrder.onclick = () => __awaiter(this, void 0, void 0, function* () {
            if (this._order.paymentInfo.payment.paymentURL) {
                document.location = this._order.paymentInfo.payment.paymentURL;
                return;
            }
            const data = new models_1.BusinessService_AwaitOrderPaymentPendingLP_Request();
            data.orderId = this._order.id;
            const update = yield App_1.App.Inst.api.businessService.awaitOrderPaymentPendingLP(data, { skip: true });
            if (!update)
                return;
            this._order = update;
            document.location = this._order.paymentInfo.payment.paymentURL;
        });
        this.ctrls.btnDeleteOrder.onclick = () => __awaiter(this, void 0, void 0, function* () {
            const data = new models_1.BusinessService_CancelOrderByCustomer_Request();
            data.orderId = this._order.id;
            const update = yield App_1.App.Inst.api.businessService.cancelOrderByCustomer(data, { skip: true });
            if (!update)
                return;
            if (update.statusInternal == models_1.OrderStatusEnum.CanceledByCustomer)
                this.cut();
        });
        this.ctrls.btnRepeatOrder.onclick = () => {
            AppPM_1.AppPM.Cart.clear();
            for (const po of this._order.products) {
                if (po.id == App_1.App.DeliveryId)
                    continue;
                AppPM_1.AppPM.Cart.addProduct(po.id, po.count, 1);
            }
            gs_1.StateGS.Run(StateCart_1.StateCart);
        };
    }
    fillAsync(order) {
        return __awaiter(this, void 0, void 0, function* () {
            this._order = order;
            const ctrl = this.ctrls;
            ctrl.blockBonus.hide();
            ctrl.lBonusCount.hide();
            ctrl.lCreateDate.text = gs.date.getDate(order.created);
            if (order.customer && order.customer.name)
                ctrl.lCustomerName.text = order.customer.name;
            else
                ctrl.lCustomerName.text = '';
            ctrl.lOrderId.text = order.id + '';
            const orderStatus = order.status;
            ctrl.lStatus.text = Helper_1.Helper.getOrderStatusDescriptionsRu(orderStatus).title;
            ctrl.lStatusDescription.text = Helper_1.Helper.getOrderStatusDescriptionsRu(orderStatus).description;
            ctrl.lTotalCost.text = Helper_1.Helper.toPriceString(order.totalCost);
            if (order.delivery.type == models_1.OrderDeliveryTypeEnum.LocalDelivery) {
                ctrl.lDeliveryCost.show();
                ctrl.lDeliveryCost.text = Helper_1.Helper.toPriceString(order.delivery.price);
                ctrl.lDeliveryType.text = "Курьер";
            }
            else {
                ctrl.lDeliveryType.text = "Самовывоз";
                ctrl.lDeliveryCost.hide();
            }
            ctrl.btnDeleteOrder.showSet(this._order.status == models_1.OrderStatusEnum.NeedPay);
            ctrl.btnPayOrder.showSet(this._order.status == models_1.OrderStatusEnum.NeedPay && !this._order.isPayed);
        });
    }
    _loadProductsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrl = this.ctrls;
            let products = yield App_1.App.Inst.cache.getProductsAsync(this._order.products.map(o => o.id));
            if (!products)
                return;
            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                const orderProd = this._order.products[i];
                const item = new tmpls_1.CmpProfileOrdersItemProduct();
                item.ctrls.lPrice.text = Helper_1.Helper.toPriceString(orderProd.totalPrice);
                item.ctrls.lQuantity.text = orderProd.count + "";
                item.ctrls.lSku.text = product.article;
                item.ctrls.lTitle.text = orderProd.name;
                item.ctrls.lUnitPrice.text = Helper_1.Helper.toPriceString(orderProd.costPerOne);
                const mainFoto = product.fotos.find(f => f.tag == FilesTags_1.FilesTags.ImgMain);
                if (mainFoto) {
                    item.ctrls.imgProductImage.src = "/fs/products/pv256/" + mainFoto.id;
                }
                ctrl.listProducts.append(item);
            }
        });
    }
}
exports.CmpProfileOrdersItem = CmpProfileOrdersItem;
//# sourceMappingURL=CmpProfileOrdersItem.js.map